// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" ng-if=\"vm.isLoading\"> </wt-loading-panel> <div class=\"fill\" id=\"performance-heat-map\" style=\"overflow-x:hidden\"> <svg></svg> </div> </div>";
// Exports
module.exports = code;